import { render, staticRenderFns } from "./FormArchive.vue?vue&type=template&id=40c91b1e"
import script from "./FormArchive.vue?vue&type=script&lang=js"
export * from "./FormArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports